<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>All Key Metadata Report</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content">
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="form-group row mb-0 my-lg-0">
        <div
          class="d-flex flex-column flex-lg-row justify-content-lg-start my-2 my-lg-0 mb-lg-0"
        >
          <div class="col-lg-5 my-1 pl-lg-0 pr-lg-1">
            <div class="form-group mb-md-0">
              <label class="mb-0">Title</label>
              <input v-model="searchData.searchMacroName" type="email" class="form-control my-md-2 my-lg-0" />
            </div>
          </div>

          <div class="col-12 col-lg-2 my-1 align-self-end">
            <span type="button" class="save_btn w-100"  @click="SearchMacroByName()">
              {{ $t("navigations.search") }}
            </span>
          </div>
          <div class="col-2 align-self-end">
        <label v-if="versionList!=null" class="mb-0" for="interimVersion">{{ $t("navigations.interim version")}}</label>
        <select class="form-select" @change="GetMetaDataList()" name="interimVersion" id="interimVersion" v-model="interimVersion">
    
          <option v-for="version in versionList" :key="version" :value="version">
            {{ version }}
          </option>
        </select>
      </div>
        </div>
        
      </div>
      
    </div>
    <div class="ibox-body">
      <!-- <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ "Macro List" }}</h5>
        <div
          class="position-relative align-self-center"
          aria-label="Create User"
          tabindex="0"
          @click.prevent="gotTo('stats')"
        >
          <img
            width="20"
            class="cursor-pointer"
            src="../../assets/img/create.png"
            alt="Create Macro"
          />
          <div class="tool-tip">Create Macro</div>
        </div>
      </div> -->
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Entry Number " }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Entry Type " }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Title" }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Program Name " }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Programmer Name " }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Assigned Primary " }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Assigned Qc " }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Status " }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Program Validator " }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Validation Type " }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('firstName', 1)" id="1">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Qc Name " }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                
                <!-- <th>Email</th> -->
                <!-- <th class="sort_block" @click="SortSelected('role',3)" id="3">
                    Role
                    <div class="d-flex flex-row justify-content-between">              
                                     <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span></div>
                  </th> -->
                
                <th class="sort_block" @click="SortSelected('locked', 4)" id="4">
                  <div class="d-flex flex-row justify-content-between">
                    {{ "Updated Datetime" }}
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <!-- <th>Locked</th> -->

                <!-- <th class="text-center">{{ " Edit" }}</th>
                <th class="text-center">{{ "Delete" }}</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="macro in MetaDataList" :key="macro.id">
                <td>{{ macro.EntryNumber }}</td>
                <td>{{ macro.EntryType }}</td>
                <td>{{ macro.Title }}</td>
                <td>{{ macro.ProgramName }}</td>
                <td>{{ macro.ProgrammerName }}</td>
                <td>{{ macro.AssignedPrimary }}</td>
                <td>{{ macro.AssignedQc }}</td>
                <td>{{ macro.ProgramValidationStatus }}</td>
                <td>{{ macro.ProgramValidator }}</td>
                <td>{{ Array.isArray(macro.ValidationType) ? macro.ValidationType.join(', ') : '' }}</td>
                <td>{{ macro.StatQcName }}</td>
                <td>{{ filter(macro.CreatedAt) }}</td>
                <!-- <td class="text-center"><span  @click="gotTo('route',macro._id)"><i class="fa fa-edit edit-delete"></i></span></td>
                <td class="text-center"><span  @click="gotTo('delete',macro._id)"><i class="fa fa-trash edit-delete"></i></span></td> -->
              </tr>
            </tbody>
          </table>
          <!------ pagination -------->
          <div class="row mx-0">
            <div class="col-lg-12 mx-0 px-0">
              <div
                class="dataTables_paginate paging_simple_numbers pagination float-right"
              >
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination
                    v-model="currentPage"
                    :pages="totalItems"
                    :range-size="1"
                    active-color="#618bd7"
                    @update:modelValue="loadPage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./analysis_report.js"></script>

<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
.form-group {
  margin-bottom: 0 !important;
}
.create-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.25rem;
}
.form-select {
  border-radius: 0 !important;
}
.form-select:focus {
  border-color: #145faf !important;
  box-shadow: 0 0 0 !important;
}

.cursor-pointer {
  cursor: pointer;
}
.position-relative {
  position: relative;
}
.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -30px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}
.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.scrollable3 {
  overflow-y: scroll;
  height: 250px;
}
.audit__details__modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}
.audit__details__modal__container {
  width: min(90%, 365px);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}
.audit__details__modal__title,
.audit__history__modal__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}
.audit__details__modal__content {
  overflow-y: scroll;
  height: 250px;
}
.audit__history__modal__contents {
  overflow-y: scroll;
  height: 404px;
}
.audit__history__modal__wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 4000;
}
.audit__history__modal__container {
  width: min(45%, 90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}
</style>
